module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Nazwa sekcji",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.section[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.section, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "section[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nazwa widoczna dla użytkowników",
      "error": _vm.errors.display_name
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.section.display_name),
      callback: function($$v) {
        _vm.$set(_vm.section, "display_name", $$v)
      },
      expression: "section.display_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zwielokrotniaj sekcję",
      "error": _vm.errors.multiply
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.section.multiply),
      callback: function($$v) {
        _vm.$set(_vm.section, "multiply", $$v)
      },
      expression: "section.multiply"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Odpowiedzi nie moga się powtarzać",
      "error": _vm.errors.unique_answers
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.section.unique_answers),
      callback: function($$v) {
        _vm.$set(_vm.section, "unique_answers", $$v)
      },
      expression: "section.unique_answers"
    }
  })], 1)], 1), _vm._v(" "), _c('fields-input', {
    attrs: {
      "fields": _vm.section.fields,
      "errors": _vm.errors.fields || []
    },
    on: {
      "update:fields": function($event) {
        return _vm.$set(_vm.section, "fields", $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bbf5ad0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CustomForms/SectionForm.vue
// module id = 726
// module chunks = 0